import { Brand } from './refs/refs'
import { FileData } from './files'
import { WorkObject } from './objects'
import { ID } from '../types/UtilityTypes'
import { Tag } from './tags'


export interface SearchResult {
    id: number,
    previews: FileData[],
    type: {
        name: string,
        short_name: string,
        color: string
    },
    project: {
        id: number,
        code: string,
        name: string,
        opened_at: string,
        brand: Brand
    },
    project_work_object: {
        id: ID,
        name?: string,
        tags: Tag[],
        work_object_type: {
            id: ID,
            work_object: WorkObject,
        }
    }
}